<template>
  <el-dialog :title="dialogName" :class="[currentTheme]" :visible.sync="dialogVisible" class="no-header-dialog"  :close-on-click-modal="false" width="100%" :fullscreen="true"  append-to-body>
    <div class="main-box examine-main">
        <!-- 左侧结构 -->
        <div class="left-panel">
          <xr-table ref="xrTable" :configure="configure">
            <template slot="listParam">
               <el-form ref="dataForm" class="main-form" :model="configure.listParam" label-suffix="：">
                  <el-row :gutter="15">
                    <el-col :span="12">
                      <el-form-item label="姓名">
                        <el-input v-model="configure.listParam.searchText" placeholder="请输入姓名"></el-input>
                          <div class="th-button" @click="search"><i class="wk"/><span>查询</span></div>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
            </template>
          </xr-table>
        </div>
        <!-- 右侧内容 -->
        <div class="right-panel">
          <el-form ref="dataForm" class="main-form" :model="formData" label-width="120px" label-suffix="：">
            <div class="panel-header">
             <div class="but-list">
               <div class="single-but-list">
                 <div class="th-button" @click="saveItems()" :disabled="isSelectedPatient"><i class="wk wk-preservation"></i><span>保存</span></div>
               </div>
               <div class="single-but-list">
                <div class="th-button" @click="back()"><i class="wk wk-back"></i><span>关闭</span></div>
               </div>
             </div>
              <div class="">
                <div class="check-box-group" v-if="examineItems">
                  <span class="check-label">体检项目：</span>
                  <el-checkbox-group v-model="selectedItems">
                    <el-checkbox  v-for="item in examineItems" :key="item.examineItemCode"  :label="item.examineItemCode" >
                      {{ item.examineItemName }}
                    </el-checkbox>
                  </el-checkbox-group>
                   <el-button type="primary" class="save-btn" @click="saveItems">保存</el-button>
                </div>
              </div>
            </div>
            <!-- 体检项目 -->

            <!-- 体检内容 -->
            <el-card class="card-bottom" v-if="isSelectedPatient">
              <!-- 基本信息 -->
              <div class="card-patient">
                  <el-row :gutter="24">
                    <el-col :span="6">
                      <el-form-item  label="档案编号" prop="archiveCode">
                        <el-input  v-model="formData.archiveCode"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item  label="姓名" prop="sickName">
                        <el-input  v-model="formData.sickName"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item  label="体检日期" prop="medicalTime">
                        <el-date-picker v-model="formData.medicalTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%"></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item  label="责任医生" prop="medicalOperatorName">
                        <el-input  v-model="formData.medicalOperatorName"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item  label="检查地点" prop="medicalWayName">
                        <el-select  v-model="formData.medicalWayName"  style="width: 100%;">
                          <el-option value="1">门诊</el-option>
                          <el-option value="2">家庭</el-option>
                          <el-option value="3">其它</el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item  label="录入团队" prop="teamName">
                        <el-input  v-model="formData.teamName" readonly></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item  label="录入医生" prop="createOpera">
                        <el-input  v-model="formData.createOpera" readonly></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>


              <!-- tab页内容 -->
              <examine-form-tabs
                :examine-items="examineItems"
                :active-tab.sync="activeTab"
                :form-data="formData"
                :medical-dic-list="medicalDicList"
              ></examine-form-tabs>
            </el-card>

            <!-- 未选择患者时的提示 -->
            <el-card class="card-bottom" v-else>
            <div class="empty-tip">
              <p>请从左侧列表中选择患者</p>
            </div>
          </el-card>
          </el-form>
       </div>
    </div>
  </el-dialog>
</template>
<script>
import ExamineFormTabs from './examine-form-tabs.vue'

export default {
    name: "projectAddOrEdit",
    data() {
      return {
        dialogVisible: false,
        dialogName: '体检检查',
        // 体检项目列表
        examineItems: [],
        // 选中的体检项目
        selectedItems: [],
        // 是否选中患者信息
        isSelectedPatient: false,
        // 当前激活的tab
        activeTab: '',
        medicalDicList:[],    //表单字典表
        formData: {
          //基本信息
          archiveCode:'',
          medicalNo: '',
          sickName: '',
          medicalTime: '',
          medicalOper: '',
          medicalOperatorName:'',
          medicalWayName: '',
          manageTeamName: '',
          createOpera: '',
          teamName:'',
        },
        configure: {
            url: '/web/service?method=tPhEnterExamineRegister_listAll',
            listParam: {
              searchText: '',
              startDate: '',
              endDate: '',
            },
            pagination: false,
            isShowToolbar: false,
            that: this,
            columns: [
              {
                field:'sn',
                title:'序号'
              },
              {
                field: 'sickName',
                title: '姓名',
                condition: {
                  searchType: 'input',
                  searchName: 'sickNameSearch',
                  value: ''
                },
                that: this,
                cellType: 'click',
                formatter: function(value){
                  return '<a class="info-a">' + value +  '</a>';
                },
                handler: function (row) {
                  this.that.handleRowClick(row);
                }
              },
              {
                field: 'sickSex',
                title: '性别',
                condition: {
                  searchType: 'select',
                  searchName: 'sickSexSearch',
                  value: '',
                  selectList: [
                    {value: '', label: ''},
                    {value: '1', label: '男'},
                    {value: '2', label: '女'}
                  ]
                },
              },
            ],

            onDBClickRow: function(row){
            //  this.that.dbClick(row);
            },
          },
      }
    },
    components: {
      ExamineFormTabs
    },
    computed: {
      currentTheme() {
        return this.$store.getters.themeType; //获取当前的主题类型
      },
    },
    methods: {
      init(){
        this.dialogVisible = true
        this.$nextTick(()=>{
          this.getPageInfo()
          this.loadSelectedItems()
        })
      },

      // 获取体检项目列表
      getPageInfo(){
        return this.request({
          method:'post',
          url:'/web/service?method=tExamineItem_getExamineItemPageInfo',
          params:{
          }
        }).then((response) =>{
          if(response.code !== 0){
            this.$message.error(response.msg)
            return false
          }
          if(!!response.data && !! response.data.item_list_tree){
            this.examineItems = response.data.item_list_tree
          }
          //表单字典表
          if(!!response.data && !! response.data.medical_dic_list){
            this.medicalDicList = response.data.medical_dic_list
          }
        })
      },

      // 从localStorage加载选中的项目
      loadSelectedItems(){
        const saved = localStorage.getItem('examineSelectedItems')
        if(saved){
          try{
            this.selectedItems = JSON.parse(saved)
          }catch(e){
            console.error('解析localStorage数据失败:', e)
          }
        }
      },

      // 保存选中的项目到localStorage
      saveItems(){
        localStorage.setItem('examineSelectedItems', JSON.stringify(this.selectedItems))
        this.$message.success('保存成功')
      },

      // 查询
      search(){
         this.$refs.xrTable.getData();
      },


      // 点击列表行
      handleRowClick(row){
        this.isSelectedPatient = true
        if(this.examineItems.length > 0){
          this.activeTab = this.examineItems[0].value
        }
        //根据archiveId 获取页面所示内容
        this.getExamineData(row.id,row.archiveId)
      },

    //获取每个体检项目的所有体检项
    getExamineData(id,archiveId){
      return this.request({
        method:'post',
        url:'/web/service?method=tExamineData_getExamineFormPageInfo',
        params:{
          archiveId: archiveId,
          registerId: id
        }
      }).then((response) =>{
        if(response.code !== 0){
          this.$message.error(response.msg)
          return false
        }
        if(!!response.data && !! response.data.info){
          this.formData = response.data.info
        }
      })
    },
    // 保存当前体检项目数据
    saveFormData(){

    },

     back(){
       this.dialogVisible = false
     },

     resetForm(){
       this.isSelectedPatient=false
     }

    }
  }
</script>
<style scoped>

.examine-main {
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.left-panel {
  width: 350px;
  height: 100%;
  border-right: 1px solid #e4e7ed;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* 搜索表单布局 */
.main-table-form {
  display: flex;
  align-items: center;
  gap: 8px;
}

.main-table-form .el-form-item {
  display: flex;
  align-items: center;
  margin-bottom: 0;
}

.main-table-form .el-form-item__content {
  flex: 1;
  min-width: 0;
}

.main-table-form .el-input {
  width: 100%;
  max-width: 160px;
}

/* 右侧面板布局 */
.right-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 20px;
  overflow-y: auto;
}

.card-top {
  flex-shrink: 0;
}

.card-bottom {
  flex: 1;
  min-height: 800px;
  display: flex;
  flex-direction: column;
}

.check-box-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  justify-content: flex-end;
}

.check-label {
  font-weight: bold;
  white-space: nowrap;
  font-size: 16px;
}


/* 基本信息卡片 */
.card-patient {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e4e7ed;
}

/* tab页卡片 */
.card-tabs {
  flex: 1;
  min-height: 300px;
}
.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.check-box-group .el-checkbox {
  margin-right: 15px;
}


.result-content {
  text-align: center;
  color: #999;
  padding: 40px 0;
}
.but-list {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: 20px;
  margin-right: 20px;
}
.single-but-list {
  display: inline-block;
}

/* 表单操作按钮 */
.form-actions {
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #e4e7ed;
}

.form-actions .el-button {
  margin-left: 0;
}

.empty-tip{
  font-size: 14px;
  font-weight: 200;
}
</style>
<style>
/* 去掉dialog的滚动条 */
.no-header-dialog .el-dialog__body {
  padding: 0 !important;
  height: calc(100vh - 80px) !important;
  overflow: hidden !important;
}
</style>



// WEBPACK FOOTER //
// src/views/examine/examine-check-index.vue